export enum DocType {
  Pdf = 'pdf',
  Csv = 'csv',
  Xls = 'xls',
  Zip = 'zip',
}

export enum AssetType {
  Video = 'video',
  Image = 'image',
  Document = 'doc',
  Audio = 'audio',
}
